import React from 'react';

import BaseAgGridTable from 'Components/AgGrid/BaseAgGridTable';
import {
  firstName,
  lastName,
  destination,
  country,
  iataCode,
  season,
  staffSourceMarket,
  preferredFlightDate,
  typeOfFlight,
} from 'Components/AgGrid/commonColumnDefs';

const columns = [
  firstName(),
  lastName(),
  destination(),
  country(),
  iataCode(),
  season(),
  staffSourceMarket(),
  preferredFlightDate(),
  typeOfFlight(),
];

const StatusPendingDesAgGridTable = () => (
  <BaseAgGridTable
    endpoint="staff/agGridTable/PendingDES"
    viewName="StatusPendingDes"
    statusPath="pendingdes"
    columns={columns}
  />
);

export default StatusPendingDesAgGridTable;
